
import { Component, Vue, Watch } from "vue-property-decorator";
import { apiShopDetail, apiShopChangeSuperAdmin } from "@/api/shop";
@Component
export default class UpdateAccount extends Vue {
    /** S Data **/

    identity: number | null = null; // ข้อมูลประจำตัวของผู้ใช้การแก้ไขปัจจุบันID

    // เพิ่มข้อมูลแบบฟอร์มร้านค้า
    form: any = {
        super_admin: "", // บัญชี
        super_password: "", // รหัสผ่าน
        super_password_confirm: "", // ยืนยันรหัสผ่าน
    };

    // การตรวจสอบแบบฟอร์ม
    rules = {
        super_admin: [
            { required: true, message: "กรุณากรอกบัญชีร้านค้า", trigger: "blur" },
        ],
        super_password: [
            { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
        ],
        super_password_confirm: [
            { required: true, message: "กรุณากรอกรหัสผ่านอีกครั้ง", trigger: "blur" },
            {
                validator: (rule: object, value: string, callback: any) => {
                    if (this.form.password) {
                        if (!value) callback(new Error("กรุณากรอกรหัสผ่านอีกครั้ง"));
                        if (value !== this.form.password)
                            callback(new Error("รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน!"));
                    }
                    callback();
                },
                trigger: "blur",
            },
        ],
    };

    /** E Data **/

    /** S Methods **/
    // คลิกเพื่อส่งแบบฟอร์ม
    onSubmit(formName: string) {
        // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
        const refs = this.$refs[formName] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;
            this.handleShopEdit();
        });
    }

    // แก้ไขบัญชีผู้ดูแลระบบขั้นสูง
    async handleShopEdit(): Promise<void> {
        await apiShopChangeSuperAdmin({ ...this.form, id: this.identity });
        setTimeout(() => this.$router.go(-1), 500);
    }

    // รับรายละเอียด
    async getShopDetailFunc(): Promise<void> {
        const res: any = await apiShopDetail({
            id: this.identity as number
        })
        this.form.super_admin = res.account // บัญชี
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        const query: any = this.$route.query;

        // โหมดแก้ไข：ข้อมูลการเริ่มต้น
        this.identity = +query.id;
        if (+query.id) {
            this.getShopDetailFunc();
        }
    }
    /** E Life Cycle **/
}
